import { footerTaxoCtaSelector, footerClientLoadingSelector } from 'store/selectors';
import { useAppSelector } from 'store/store';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import FooterLinks from './FooterLinks';

const FooterLinksContainer = () => {
  const cta = useAppSelector(footerTaxoCtaSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!cta && isLoading) {
    return null;
  }

  if (!cta) {
    throw new Error(
      'Homr did not return any "Footer Links" cta content. Make sure the correct data is being returned!',
    );
  }
  return (
    <ErrorBoundaryWithLogger componentId="Footer-FooterLinks">
      <FooterLinks cta={cta} />
    </ErrorBoundaryWithLogger>
  );
};

export default FooterLinksContainer;
